import { useSearchParams } from "react-router-dom";

import {
  BusbarModePicker,
  busbarModeOf,
  DEFAULT_BUSBAR_MODE,
  type BusbarMode,
} from "../components/BusbarModePicker";
import { BusbarEvidencePage } from "./BusbarEvidencePage";
import { BusbarSelectionPage } from "./BusbarSelectionPage";

// EOS-07's busbar page: two modes, selection (EOS-07c, the default) and the builder's evidence
// (EOS-07a). The mode is in the address (?mode=selection or ?mode=evidence; a missing or
// unknown value is selection), so Back, Forward and a shared link restore it. Only the shown
// mode is mounted; each form keeps its draft under its own module key, so changing the mode
// never clears either one.
export function BusbarPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const mode = busbarModeOf(searchParams.get("mode"));

  // A new history entry, so Back returns to the mode that was shown; other parameters stay.
  function changeMode(next: BusbarMode) {
    setSearchParams((current) => {
      const updated = new URLSearchParams(current);
      if (next === DEFAULT_BUSBAR_MODE) {
        updated.delete("mode");
      } else {
        updated.set("mode", next);
      }
      return updated;
    });
  }

  const modePicker = <BusbarModePicker mode={mode} onChange={changeMode} />;

  return mode === "evidence" ? (
    <BusbarEvidencePage modePicker={modePicker} />
  ) : (
    <BusbarSelectionPage modePicker={modePicker} />
  );
}

export default BusbarPage;
